import axios from 'axios';
import {MutationNames} from '@/constants/MutationNames';
import store from '@/store';

export default() => {
  let baseURL;

  if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://opwaarderen.oudlaen.nl/api';
  } else if (process.env.NODE_ENV === 'test') {
    baseURL = 'http://oudlaen.local/api';
  } else {
    baseURL = 'http://oudlaen.local/api';
  }

  const api = axios.create({
    baseURL,
  });

  api.interceptors.response.use((res) => {
    return res;
  }, (err) => {
    if (err.response.status === 401) {
      store.commit(MutationNames.LOG_OUT);
    } else {
      return Promise.reject(err);
    }
  });

  return api;
};
